export const KNOWLEDGE_BASE_SWITCHER_STEP = 'knowledge base switcher';
export const CREATE_ARTICLE_STEP = 'create article button';
export const INSIGHTS_STEP = 'insights button';
export const CONFIGURE_STEP = 'configure button';
export const NEW_USER_ONBOARDING_TOUR_NAME = 'knowledge-base-new-user-tour';
export const NEW_USER_ONBOARDING_TOUR_CONFIG = {
  steps: [KNOWLEDGE_BASE_SWITCHER_STEP, CONFIGURE_STEP, CREATE_ARTICLE_STEP, INSIGHTS_STEP]
};